export interface FilterItem{
  id: string;
  label: string;
  labelTooltip?: string;
  open: boolean;
  viewMore: boolean;
  required?: boolean;
}

// Enums mapping the different filters with their respective IDSs
export enum LiquidationTypes {
  LIQUIDATED = "2",
  NOT_LIQUIDATED = "1"
}

export enum CollectionTypes {
  CLOSED = "1",
  NOT_CLOSED = "2"
}

export enum BillingTypes {
  PAID = "1", //Abonada
  CANCELED = "2", //Anulada
  PARCIAL_COLLECTED = "3", //Cobrada parcial
  TOTAL_COLLECTED = "4", //Cobrada total
  PENDING_PAY = "5", //Pdte. cobro
  PENDING_AUTOMATIC_BILLING = "6", //Pdte fcaturacion automatica
  PENDING_BILL = "7", //Pdte facturacion
  FORFAIT = "8" //Sustituido por forfait
}